import { render, staticRenderFns } from "./confirme-seu-codigo.vue?vue&type=template&id=f65719dc&"
import script from "./confirme-seu-codigo.vue?vue&type=script&lang=js&"
export * from "./confirme-seu-codigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports